// extracted by mini-css-extract-plugin
export default {"twoColumnPicture":"Home_twoColumnPicture__uNJqw"};